import React from 'react';
import { TrendingUp, FileCheck, Bell, Globe } from 'lucide-react';
import { benefits } from '../data/mock';

const iconMap = {
  'trending-up': TrendingUp,
  'file-check': FileCheck,
  'bell': Bell,
  'globe': Globe,
};

const Benefits = () => {
  return (
    <section 
      id="benefits" 
      className="bg-gradient-to-b from-blue-50 to-white"
      style={{ paddingTop: '80px', paddingBottom: '80px' }}
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        {/* Section Header - Centered */}
        <div className="text-center mb-12">
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 leading-tight mx-auto"
            style={{ 
              maxWidth: '20ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Why Choose Us
          </h2>
          <p 
            className="text-lg sm:text-xl text-gray-600 mx-auto leading-relaxed"
            style={{ 
              maxWidth: '48ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            We leverage AI technology to maximize your compensation success
          </p>
        </div>

        {/* Image Left + Text Right Layout - Vertically Centered */}
        <div 
          className="grid lg:grid-cols-2"
          style={{ gap: '48px', alignItems: 'center' }}
        >
          {/* Left: Image with 3D hover effect */}
          <div className="relative order-2 lg:order-1 group">
            <div className="absolute inset-0 bg-gradient-to-br from-blue-600/20 to-transparent rounded-3xl transform -rotate-3 transition-transform duration-300 group-hover:-rotate-2" />
            <img 
              src="https://images.unsplash.com/photo-1708275771888-c4e72cf8fa75"
              alt="AI-powered claims processing"
              className="relative rounded-3xl shadow-2xl w-full h-auto object-cover transition-all duration-300 group-hover:shadow-3xl group-hover:translate-y-[-4px]"
            />
          </div>

          {/* Right: Benefits List - Vertically centered with image */}
          <div 
            className="order-1 lg:order-2"
            style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
          >
            {benefits.map((benefit, index) => {
              const Icon = iconMap[benefit.icon];
              return (
                <div 
                  key={index} 
                  style={{ 
                    display: 'flex', 
                    alignItems: 'flex-start',
                    gap: '16px'
                  }}
                >
                  {/* Icon - Fixed 48px width */}
                  <div style={{ width: '48px', flexShrink: 0 }}>
                    <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center transition-transform duration-300 hover:scale-110">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  
                  {/* Text - Vertical Stack */}
                  <div style={{ flex: 1 }}>
                    <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-sm">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-16 border-t border-gray-200 mt-16">
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">95%</p>
            <p className="text-sm text-gray-600 font-medium">Success Rate</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">€15M+</p>
            <p className="text-sm text-gray-600 font-medium">Recovered</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">50K+</p>
            <p className="text-sm text-gray-600 font-medium whitespace-nowrap">Happy Passengers</p>
          </div>
          <div className="text-center">
            <p className="text-4xl font-bold text-blue-600 mb-2">12+</p>
            <p className="text-sm text-gray-600 font-medium">Languages</p>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Benefits;
